import React, {useState, useCallback} from 'react';
import {View, StyleSheet, ScrollView, TouchableOpacity} from 'react-native';
import {Text} from 'react-native-paper';
import {useTranslation} from 'react-i18next';
import {useNavigation, DrawerActions} from '@react-navigation/native';
import GradientHeader from '../../components/common/GradientHeader';
import {colors, spacing} from '../../theme';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

const FAQ_KEYS = Array.from({length: 15}, (_, i) => i + 1);

const FAQItem = ({question, answer, isOpen, onToggle}) => (
  <View style={styles.faqItem}>
    <TouchableOpacity
      style={styles.questionRow}
      onPress={onToggle}
      activeOpacity={0.7}>
      <Text style={styles.questionText}>{question}</Text>
      <MaterialCommunityIcons
        name={isOpen ? 'chevron-up' : 'chevron-down'}
        size={22}
        color={colors.textSecondary}
      />
    </TouchableOpacity>
    {isOpen && <Text style={styles.answerText}>{answer}</Text>}
  </View>
);

const FAQScreen = () => {
  const {t} = useTranslation();
  const navigation = useNavigation();
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = useCallback(
    idx => {
      setOpenIndex(prev => (prev === idx ? null : idx));
    },
    [],
  );

  return (
    <View style={styles.container}>
      <GradientHeader title={t('faq.title')} onMenu={() => navigation.dispatch(DrawerActions.openDrawer())} />

      <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
        <View style={styles.card}>
          {FAQ_KEYS.map((num, idx) => (
            <FAQItem
              key={num}
              question={t(`faq.q${num}`)}
              answer={t(`faq.a${num}`)}
              isOpen={openIndex === idx}
              onToggle={() => handleToggle(idx)}
            />
          ))}
        </View>
        <View style={{height: spacing.xxl}} />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {flex: 1, backgroundColor: colors.background},
  content: {flex: 1, padding: spacing.md},

  card: {
    backgroundColor: colors.surface,
    borderRadius: 12,
    overflow: 'hidden',
  },

  faqItem: {
    borderBottomWidth: 1,
    borderBottomColor: colors.divider,
  },
  questionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: spacing.md,
    gap: spacing.sm,
  },
  questionText: {
    flex: 1,
    fontSize: 15,
    fontWeight: '600',
    color: colors.text,
    lineHeight: 22,
  },
  answerText: {
    fontSize: 14,
    color: colors.textSecondary,
    lineHeight: 22,
    paddingHorizontal: spacing.md,
    paddingBottom: spacing.md,
    paddingTop: 0,
  },
});

export default FAQScreen;
